export const developersStatuses = [
  {
    text: 'queued',
    theme: 'warning',
    icon: 'Clock',
    value: 0
  },
  {
    text: 'delivered',
    theme: 'success',
    icon: 'Check',
    value: -1
  },
  {
    text: 'failed',
    theme: 'danger',
    icon: 'Close',
    value: 1
  },
  {
    text: 'failed',
    theme: 'danger',
    icon: 'Close',
    value: 2
  }
];
